module.exports = __webpack_public_path__ + "img/jam_instagram-circle.4eebf077.svg";